import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.#refreshAndOpen();
    }
  };

  #refreshAndOpen = async () => {
    await this.#refreshCart();
    this.showDialog();
  };

  #refreshCart = async () => {
    const sectionId = this.querySelector('cart-items-component')?.dataset.sectionId;
    if (!sectionId) return;

    try {
      const res = await fetch(`/?sections=${sectionId}`);
      const data = await res.json();

      if (data[sectionId]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data[sectionId], 'text/html');

        const newCartItems = doc.querySelector('cart-items-component');
        const currentCartItems = this.querySelector('cart-items-component');

        if (newCartItems && currentCartItems) {
          currentCartItems.innerHTML = newCartItems.innerHTML;
        }

        // Sync the empty/non-empty class on the dialog
        const newDialog = doc.querySelector('.cart-drawer__dialog');
        const currentDialog = this.querySelector('.cart-drawer__dialog');
        if (newDialog && currentDialog) {
          currentDialog.classList.toggle(
            'cart-drawer--empty',
            newDialog.classList.contains('cart-drawer--empty')
          );
        }
      }
    } catch (err) {
      console.error('Cart refresh failed:', err);
    }
  };

  open() {
    this.showDialog();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}